import type { OfferPreset } from "../../types"

import hero from "@/features/offers/assets/compatibility/hero.webp"
import feature1 from "@/features/offers/assets/compatibility/feature-1.svg"
import feature2 from "@/features/offers/assets/compatibility/feature-2.svg"
import feature3 from "@/features/offers/assets/compatibility/feature-3.svg"
import gift from "@/features/offers/assets/compatibility/gift.webp"
import card1 from "@/features/offers/assets/compatibility/card-1.webp"
import card2 from "@/features/offers/assets/compatibility/card-2.webp"
import chip12Signs from "@/features/offers/assets/compatibility/chip-12signs.svg"
import chipLoveFit from "@/features/offers/assets/compatibility/chip-lovefit.svg"
import chipPairDynamics from "@/features/offers/assets/compatibility/chip-pairdynamics.svg"
import chipTrust from "@/features/offers/assets/compatibility/chip-trust.svg"
import chipValues from "@/features/offers/assets/compatibility/chip-values.svg"
import chipEmotion from "@/features/offers/assets/compatibility/chip-emotion.svg"
import reviewer4 from "@/features/offers/assets/compatibility/reviewer-4.webp"
import reviewer5 from "@/features/offers/assets/compatibility/reviewer-5.webp"
import reviewer6 from "@/features/offers/assets/compatibility/reviewer-6.webp"

export const compatibilityPreset: OfferPreset = {
  key: "compatibility",
  stepLabel: "Love",
  unlockedLabel: "Exclusive Compatibility Match unlocked",
  hero: {
    title: "Reveal Your Love Match",
    subtitle: "The comprehensive breakdown of what really happens when your energies meet: the signs you naturally align or unconsciously clash with.",
    bg: hero,
  },
  benefits: [
    {
      icon: feature1,
      title: "Connection Blueprint",
      subtitle: "How attraction, emotions, communication, and core values align — or clash.",
    },
    {
      icon: feature2,
      title: "Trust & Loyalty Compass",
      subtitle: "A straight look at where jealousy hides, where boundaries blur, and where suspicion may arise.",
    },
    {
      icon: feature3,
      title: "Long‑Term Forecast",
      subtitle: "What challenges could strain your bond — and what strengths can hold it together.",
    },
  ],
  gift: {
    title: "Blind Spot Detector",
    subtitle: "A focused scan that flags the hidden risks: the ones that quietly undermine trust.",
    image: gift,
    strikePrice: "$19.99",
    fillImage: true,
  },
  price: {
    heading: "Claim Your Full Love Match Reading",
    reportLabel: "Compatibility Match Report",
    giftLabel: "Blind Spot Detector",
  },
  ctaLabel: "Get Love Truths Now",
  ctaStickyLabel: "Unlock Love Truths",
  featureCards: {
    heading: "Discover What Your Stars Reveal About Your Life",
    cards: [
      {
        image: card1,
        title: "Zodiac Compatibility",
        subtitle:
          "Explore how your sign resonates with all 12 others. From effortless magnetism to places where opposites truly collide — see the full picture of every possible pair.",
        chips: [
          { icon: chip12Signs, label: "12 Signs" },
          { icon: chipLoveFit, label: "Love Fit" },
          { icon: chipPairDynamics, label: "Pair Dynamics" },
        ],
      },
      {
        image: card2,
        title: "The Heart of Every Match",
        subtitle:
          "Go beneath the surface. Understand the real drivers behind each connection — what flows naturally, what rubs the wrong way, and what quietly asks for care.",
        chips: [
          { icon: chipTrust, label: "Trust", tone: "cyan" },
          { icon: chipValues, label: "Values", tone: "green" },
          { icon: chipEmotion, label: "Emotion", tone: "gold" },
        ],
      },
    ],
  },
  reviews: {
    heading: "What users say after unlocking their match",
    items: [
      {
        avatar: reviewer4,
        name: "Olivia Hart",
        rating: "4.9",
        text: "I wanted to understand why we kept arguing over the same things. The trust and warning signs sections made the patterns much clearer.",
      },
      {
        avatar: reviewer5,
        name: "Noah Bennett",
        rating: "5.0",
        text: "The compatibility report felt more useful than a simple love horoscope. It explained both the chemistry and the tension in our relationship.",
      },
      {
        avatar: reviewer6,
        name: "Emma Reed",
        rating: "4.8",
        text: "I liked that it didn’t only say if we were a good match. It showed where the connection works and where we need to be more careful.",
      },
    ],
  },
}
